/**
 * Stock Chart Viewer - Cache Storage
 */

import { elements } from '../ui/dom.js';

export const CACHE_KEY_PREFIX = 'stockCache_';

export function getCacheKey(symbol, period) {
    return `${CACHE_KEY_PREFIX}${symbol.toUpperCase()}_${period}`;
}

export function getCachedData(symbol, period) {
    const key = getCacheKey(symbol, period);
    const cached = localStorage.getItem(key);
    if (cached) {
        try {
            const data = JSON.parse(cached);
            console.log(`Using cached data for ${symbol} (${period})`);
            return data;
        } catch (e) {
            console.error('Cache parse error:', e);
            localStorage.removeItem(key);
        }
    }
    return null;
}

export function setCachedData(symbol, period, data) {
    const key = getCacheKey(symbol, period);
    const cacheEntry = {
        ...data,
        cachedAt: new Date().toISOString(),
    };
    try {
        localStorage.setItem(key, JSON.stringify(cacheEntry));
        console.log(`Cached data for ${symbol} (${period})`);
        renderCachedDataList();
    } catch (e) {
        console.error('Cache save error:', e);
    }
}

export function deleteCacheEntry(symbol, period) {
    const key = getCacheKey(symbol, period);
    localStorage.removeItem(key);
    console.log(`Deleted cache: ${symbol} (${period})`);
    renderCachedDataList();
}

export function getAllCachedEntries() {
    const entries = [];
    const keys = Object.keys(localStorage).filter(k => k.startsWith(CACHE_KEY_PREFIX));

    keys.forEach(key => {
        try {
            const data = JSON.parse(localStorage.getItem(key));
            const keyParts = key.replace(CACHE_KEY_PREFIX, '').split('_');
            entries.push({
                symbol: keyParts[0],
                period: keyParts[1],
                cachedAt: data.cachedAt,
                key: key,
            });
        } catch (e) {
            // Skip invalid entries
        }
    });

    return entries.sort((a, b) => new Date(b.cachedAt) - new Date(a.cachedAt));
}

export function clearAllCache() {
    const keys = Object.keys(localStorage).filter(k => k.startsWith(CACHE_KEY_PREFIX));
    keys.forEach(k => localStorage.removeItem(k));
    console.log(`Cleared ${keys.length} cached entries`);
    renderCachedDataList();
}

export function renderCachedDataList() {
    const entries = getAllCachedEntries();

    if (entries.length === 0) {
        elements.cachedDataList.innerHTML = '<p class="no-cache-msg">キャッシュデータなし</p>';
        return;
    }

    elements.cachedDataList.innerHTML = entries.map(entry => {
        const date = new Date(entry.cachedAt);
        const dateStr = date.toLocaleDateString('ja-JP', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
        return `
            <div class="cache-item" data-symbol="${entry.symbol}" data-period="${entry.period}">
                <div class="cache-item-info">
                    <span class="cache-item-symbol">${entry.symbol}</span>
                    <span class="cache-item-period">${entry.period}</span>
                    <span class="cache-item-date">${dateStr}</span>
                </div>
                <button class="cache-item-delete" title="削除">×</button>
            </div>
        `;
    }).join('');
}
